class Bundle {
  constructor() {
    this.prod = bundleProduct
    this.miniCart = document.querySelector('mini-cart')
    this.colorInputs = document.getElementsByName('Color')
    this.sizeInputs = document.getElementsByName('Size')
    this.pattern = document.getElementsByName('Pattern')[0]
    this.quantity = document.querySelector('input[name="quantity"]')
    this.id = document.querySelector('input[name="id"]')
    this.galleryThumbnails = document.querySelector('thumbnail-slider ul li:nth-child(2) button')

    this.crossSell = document.getElementsByName('CrossSell')

    this.colorSelectors = document.querySelectorAll('[data-color-selector-id]')
    this.productFormBtn = document.querySelector('.product-form__submit')

    this.errorContainer = document.querySelector('.error-container')

    this.ACTIVE_CLASS = 'active'
    this.LOADING_CLASS = 'loading'
  }

  init() {
    console.log('Bundle init')

    this.selectVariantColor()
    this.changeInputColor()
    this.changeVariantColor()
    this.checkDiscount()
    this.difPrice(this.prod)
    this.productFormBtn.addEventListener('click', this.addToCart.bind(this))
    window.addEventListener('locationchange', this.checkDiscount.bind(this))
  }

  selectVariantColor() {
    for (let i = 0; i < this.colorInputs.length; i++) {
      if (this.colorInputs[i].checked) {
        const colorId = this.colorInputs[i].dataset.colorId
        const colorSelector = document.querySelector(
          `[data-color-selector-id="${colorId}"]`
        )
        if (!colorSelector) return
        const fiber = document.querySelector('[data-color-selector-fiber]');
        if (fiber) {
          fiber.textContent = colorSelector.dataset.colorSelectorType;
          let newClick = document.querySelector('span[data-color-selector-tipo="' + fiber.textContent + '"]')
          const optionValueF = this.colorInputs[i].getAttribute('data-option-value');
          const optionValue = optionValueF.charAt(0);
          // Buscar el '.fiber-wrapper' que tenga un 'data-option-value' coincidente
          const matchingFiberWrapper = document.querySelector(`.fiber-wrapper[data-option-value="${optionValue}"]`);

          // Simular un clic en ese '.fiber-wrapper' específico
          const spanInsideFiberWrapper = matchingFiberWrapper.querySelector('span');
          if (spanInsideFiberWrapper) {
            fiber.textContent = spanInsideFiberWrapper.textContent;
            spanInsideFiberWrapper.click();
          }
        }
        colorSelector.classList.add(this.ACTIVE_CLASS)
        if (this.galleryThumbnails && this.colorInputs.length > 1) {
          this.galleryThumbnails.click()
        }
        break
      }
    }
  }
  changeInputColor() {
    this.colorSelectors.forEach((elem) => {
      elem.addEventListener('click', (e) => {
        e.stopPropagation()
        this.removeClassFromElements(this.colorSelectors, this.ACTIVE_CLASS)
        elem.classList.add(this.ACTIVE_CLASS)
        const colorId = elem.dataset.colorSelectorId
        const colorSku = elem.dataset.colorSelectorSku
        const colorTitle = elem.dataset.colorSelectorTitle
        const discountFirst = elem.dataset.discountFirst

        const img = elem.querySelector('img').src

        const termsToRemove = ["100%", "Meriwool", "Wool", "Lana", "Merino", "Superwash", "The", "Bling", "Yarn", "Petite", "Alpaca", "Baby", "Pima", "Cotton", "Wave", "Squishy", "Twist & Shout", "Tweed", "Mixed", "Touch me Mohair", "Touch Me Mohair", "Merifine", "Meripaca", "Bamboo", "Embroidery", "Thread", "Fuzzy", "Boucle Cloud"];
        let cleanedColorTitle = colorTitle;
        termsToRemove.forEach(term => {
            cleanedColorTitle = cleanedColorTitle.replace(term, "");
        });

        if (cleanedColorTitle.includes('icorn')) {
          cleanedColorTitle = 'Yarnicorn';
      }

        for (let i = 0; i < this.colorInputs.length; i++) {
          if (this.colorInputs[i].checked) {
            this.colorInputs[i].dataset.colorId = colorId
            this.colorInputs[i].dataset.colorSku = colorSku
            this.colorInputs[i].dataset.colorTitle = cleanedColorTitle
            this.colorInputs[i].nextElementSibling.firstElementChild.src = img
            this.colorInputs[i].nextElementSibling.setAttribute(
              'color-title',
              cleanedColorTitle 
            )
            this.colorInputs[i].nextElementSibling.setAttribute(
              'swatch',
              cleanedColorTitle 
            )
            discountFirst
              ? (this.colorInputs[i].dataset.discountFirst = discountFirst)
              : (this.colorInputs[i].dataset.discountFirst = '')

            const nextInput = this.colorInputs[i + 1]
            if (nextInput) {
              document.querySelector(`label[for="${nextInput.id}"]`).click()
            }
            if (this.galleryThumbnails && this.colorInputs.length > 1) {
              this.galleryThumbnails.click()
            }
            break
          }
        }
        this.checkDiscount()
      })
    })
  }
  changeVariantColor() {
    this.colorInputs.forEach((elem) => {
      elem.addEventListener('click', () => {
        this.removeClassFromElements(this.colorSelectors, this.ACTIVE_CLASS)
        this.selectVariantColor()
      })
    })
  }

  checkDiscount() {
    const price = this.prod.variants.find(
      (variant) => variant.id == this.id.value
    ).price
    console.log('PRICE', price)
    for (let i = 0; i < this.colorInputs.length; i++) {
      const elem = this.colorInputs[i]
      const discount = elem.dataset.discountFirst
      if (discount) {
        this.#changePriceUI(price, discount)
        break
      }
      if (i === this.colorInputs.length - 1) {
        const priceCompare = document.querySelectorAll('.discount-price-bundle')
        //prettier-ignore
        priceCompare.forEach((elem) => { elem.style.display = 'none'})

        const regular = document.querySelectorAll('.price__regular')
        //prettier-ignore
        regular.forEach((elem) => {elem.classList.remove('discount-bundle-original')})
      }
    }
  }

  difPrice(bundleProduct) {
    const isSizes = document.querySelector('#isSizes')
    if (isSizes) {
      console.warn('IS SIZES')
      const priceDif = {}
      const mainOption = bundleProduct.variants[0].option2
      const variants = bundleProduct.variants.filter(
        (variant) => variant.option2 === mainOption
      )
  
      for (let i = 1; i < variants.length; i++) {
        const firstVariantPrice = variants[0].price
        const currentVariantPrice = variants[i].price
        const dif = currentVariantPrice - firstVariantPrice
        if (dif > 0) {
          priceDif[variants[i].option3] = dif
          let diff = document.querySelector(".diff."+'A'+variants[i].option3.toUpperCase().replace(/ /g, ''))
          if (diff) {
            diff.innerHTML = Number(dif / 100).toFixed(2)
          }
        } else {
          priceDif[variants[i].option3] = dif
          console.log("ES 0")
          let wrapper2 = document.querySelector(".diff-wrapper."+'A'+variants[i].option3.toUpperCase().replace(/ /g, ''))
          if (wrapper2) {
            wrapper2.style.display = "none"
          }
        }
      }
  
      for (const [key, value] of Object.entries(priceDif)) {
        console.warn(`${key}: ${value}`)
      }
    } else {
      console.warn('NO SIZES')
    }
  }

  #changePriceUI(price, discount) {
    setTimeout(() => {
      let discountPrice = 0
      discountPrice = parseInt((price * (100 - Number(discount))) / 100)
      discountPrice = discountPrice.toString()
      let rounded = discountPrice.slice(0, -2)
      let cents = discountPrice.slice(-2)
      const priceCompare = document.querySelectorAll('.discount-price-bundle')

      priceCompare.forEach((elem) => {
        const bundleMajor = elem.querySelector('.discount-bundle-major')
        bundleMajor.textContent = rounded
        elem.querySelector('.price__suffix').textContent = ',' + cents
        elem.style.display = 'block'
      })

      const regular = document.querySelectorAll('.price__regular')
      regular.forEach((elem) => {
        elem.classList.add('discount-bundle-original')
      })
    }, 1000)
  }

  removeClassFromElements(nodeList, classElement) {
    nodeList.forEach((elem) => {
      elem.classList.remove(classElement)
    })
  }
  async addToCart(e) {
    e.preventDefault()
    this.productFormBtn.setAttribute('disabled', true)
    this.productFormBtn.classList.add(this.LOADING_CLASS)
    const { kitId, bundle, colorPropertyStr, packaging, weight, discount } =
      this.getBundleValues()
    const body = {
      items: [
        {
          id: kitId,
          quantity: this.quantity ? this.quantity.value : 1,
          properties: {
            color: colorPropertyStr,
            _bundle: JSON.stringify(bundle),
            _packaging: packaging,
            _weight: weight
          }
        }
      ],
      sections: this.miniCart
        .getSectionsToRender()
        .map((section) => section.id)
        .join(',')
    }
    if (discount) {
      body.items[0].properties['_discount_kit_first'] = discount
    }
    this.crossSell.forEach((elem) => {
      if (elem.checked) {
        body.items.push({
          id: elem.dataset.crossId,
          quantity: 1,
          properties: {
            _single: true
          }
        })
      }
    })
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body),
      keepalive: true
    })
      .then((response) => response.json())
      .then((res) => {
        if (this.miniCart) {
          const cartResponse = res.items[0]
          cartResponse.sections = res.sections
          this.miniCart.renderContents(cartResponse)
        }
      })
      .catch((err) => {
        console.error('ffff', err)
      })
      .finally(() => {
        this.productFormBtn.classList.remove(this.LOADING_CLASS)
        this.productFormBtn.removeAttribute('disabled', false)
      })
  }

  getBundleValues() {
    const bundle = []
    const colors = []
    let weight = 0
    let discount = null

    const needle = document.querySelector('input[name="Needles"]:checked')
    if (needle && needle.dataset.needlesId) {
      weight += Number(needle.dataset.needlesWeight)
      bundle.push({
        quantity: needle.dataset.needlesQ || 1,
        name: needle.value,
        sku: needle.dataset.needlesSku,
        id: needle.dataset.needlesId
      })
    }
    if (this.pattern.value) {
      bundle.push({
        quantity: 1,
        name: this.pattern.dataset.patternTitle,
        sku: this.pattern.dataset.sku,
        id: this.pattern.value
      })
    }

    const sizesInput = document.querySelector('input[name="Size"]:checked')
    const needlesInput = document.querySelector('input[name="Needles"]:checked')

    const sizes = sizesInput
      ? sizesInput.dataset.kitSizesQ.split(',')
      : document.querySelector('input[name="DefaultQ"]').value.split(',')
    let packaging = sizesInput
      ? sizesInput.dataset.packaging
      : document.querySelector('input[name="defaultPackaging"]').value
    console.log('ANTIGUO PACKAGING: ', packaging)
    if (needlesInput && sizesInput) {
      let withoutNeedles = needlesInput.getAttribute('data-needles-type')
      if (withoutNeedles === 'no_needles') {
        const noNeedles = document.querySelector('input[name="no_needles"]')
        const constructOptionNeedles = sizesInput.getAttribute('data-option-value').toLowerCase()
        const constructNeedles = constructOptionNeedles+'_'+withoutNeedles
        const finalNeedles = noNeedles.getAttribute(constructNeedles)
        if (finalNeedles) {
          console.log('REEMPLAZAR: ', finalNeedles)
          packaging = finalNeedles
        }
      }
    }
    const isCompostable = document.querySelector('input[name="defaultPackaging"]');

    if (isCompostable.getAttribute('isCompostable') === "true") {
      if (packaging.includes('BAG')) {
          packaging = 'WAK-BAG-1001-0';
      }
    }

    console.log('PACKAGING FINAL: ', packaging)
    
    packaging = packaging.replaceAll(' ', '')
    for (let i = 0; i < this.colorInputs.length; i++) {
      const elem = this.colorInputs[i]

      if (!elem.dataset.colorId) {
        this.displayUnselectedColorError()
        return
      }

      weight += Number(elem.dataset.colorWeight) * sizes[i]
      if (elem.dataset.discountFirst) {
        discount = elem.dataset.discountFirst
      }
      const color = {
        id: elem.dataset.colorId,
        name: elem.dataset.colorTitle,
        sku: elem.dataset.colorSku,
        quantity: Number(sizes[i]) || 1
      }
      colors.push(color)
    }

    const totalColors = colors.reduce((acc, color) => {
      const existingColor = acc.find((c) => c.id === color.id)
      if (existingColor) {
        existingColor.quantity += color.quantity
      } else {
        acc.push(color)
      }
      return acc
    }, [])
    bundle.push(...totalColors)

    const colorPropertyStr = totalColors
      .map((color) => `x${color.quantity} ${color.name}`)
      .join(', ')

    const kitId = document.querySelector('input[name="id"]').value
    return { kitId, bundle, colorPropertyStr, packaging, weight, discount }
  }

  displayUnselectedColorError() {
    this.errorContainer.style.display = 'block'
    this.productFormBtn.classList.remove(this.LOADING_CLASS)
    this.productFormBtn.removeAttribute('disabled', false)
  }

  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper =
      this.errorMessageWrapper ||
      this.querySelector('.product-form__error-message-wrapper')

    if (this.errorMessageWrapper) {
      if (this.hideErrors) return
      this.errorMessage =
        this.errorMessage ||
        this.errorMessageWrapper.querySelector('.product-form__error-message')
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage)

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage
      }
    } else {
      if (errorMessage) {
        alert(errorMessage)
      }
    }
  }
}
;(() => {
  let oldPushState = history.pushState
  history.pushState = function pushState() {
    let ret = oldPushState.apply(this, arguments)
    window.dispatchEvent(new Event('pushstate'))
    window.dispatchEvent(new Event('locationchange'))
    return ret
  }

  let oldReplaceState = history.replaceState
  history.replaceState = function replaceState() {
    let ret = oldReplaceState.apply(this, arguments)
    window.dispatchEvent(new Event('replacestate'))
    window.dispatchEvent(new Event('locationchange'))
    return ret
  }

  window.addEventListener('popstate', () => {
    window.dispatchEvent(new Event('locationchange'))
  })
})()
const bundle = new Bundle()
bundle.init()
